import Ticker from './ticker';

export default class Asset {
  constructor(data) {
    this.tickers = [];
    this.color = null;
    this.percentage = null;
    this.label = null;
    this.originalPercentage = null;
    this.taxFlag = null;

    Object.assign(this, data);

    // we really only care about the index
    data.tickerData.labels.forEach((label, index) => {
      this.tickers.push(
        new Ticker({
          code: data.tickerData.labels[index],
          name: data.tickerData.tooltips[index],
          percentage: data.tickerData.datasets[0].data[index],
        })
      );
    });
  }

  getTaxStatusPercentage(taxStatus) {
    if (taxStatus === 'taxable') {
      return this.taxablePercentage;
    }

    return this.taxAdvantagedPercentage;
  }
}
